// Only fires if version is 0.
export default function updateTo2025(savedData) {
  const formData = { ...savedData.formData };
  delete formData.totalNetWorth;
  return {
    ...savedData,
    formData,
    metadata: { ...savedData.metadata, returnUrl: '/claimant-relationship' },
  };
}
